/**
 * Generated bundle index. Do not edit.
 */

export {NgxLoadingService,NgxLoadingComponent,NgxLoadingModule,INgxLoadingConfig,NgxLoadingConfig,ngxLoadingAnimationTypes} from './public_api';
